export const teamInfo = [
  {
    name: "Alessandro Baldassarre",
    role: "Front-end Lead",
    image:
      "https://images.immediate.co.uk/production/volatile/sites/3/2023/08/a35145e8fe1ddf12c8c945b2e5bdf3361664333053main-Cropped-d26b98e.png",
    bio: "I am a Software Engineering student at the University of Calgary. I love boxing, hiking, anime, and much more. Connect with me on LinkedIn!",
    github: "https://github.com/aleabalda",
    linkedIn: "https://www.linkedin.com/in/aleabalda/",
  },
  {
    name: "Ernesto",
    role: "Back-end Lead",
    image:
      "https://media.tenor.com/o-wNCEq_6f0AAAAe/pompo-the-cinephile-typing-fast.png",
    bio: "Software Engineering and Business student at the University of Calgary. I love to read, mountain bike, travel, learn languages, and watch anime. Visit my LinkedIn to tell me what we can improve 🙋!",
    github: "https://github.com/Ernesto-B",
    linkedIn: "https://www.linkedin.com/in/ernesto-barreto-58a9b0258",
  },
  {
    name: "Gabriel Toro",
    role: "Front-end Dev",
    image:
      "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjAHUNlP8YNrVxDQgaVzoZSHSFOW2gdNahpVw4YoFlp03pnep_0xgvN5eSgtnWf32zPC5pFQpfdcj7_CA4M3keMJMI6pW-kUK1IieqRgB9VdoxygsvtcnGx8Atkiu0YZ0Si7CBLFfkmiBQ/s1600/great+teacher+onizuka.jpg",
    bio: "A Computer Information Systems major who likes to learn languages, travel, and play games on his spare time. Will always try to get out of my comfort zone. Reach out if you have any questions!",
    github: "https://github.com/MrMoustache1",
    linkedIn: "https://www.linkedin.com/in/gabriel-toro-a6b79429a/",
  },
  {
    name: "Jose Sanchez",
    role: "Back-end Dev",
    image: "https://cdn.wallpapersafari.com/30/18/uH3j5V.jpg",
    bio: "Hello! I am a Computer Information Systems attending Mount Royal University, I like Brazilian Jiu-Jitsu, lifting weights, and playing video games. Connect with me on LinkedIn!",
    github: "https://github.com/josesanchez2004",
    linkedIn: "https://www.linkedin.com/in/jose-sanchez-35083825a/",
  },
  {
    name: "Kiaan B",
    role: "Front-end Dev",
    image: "https://i.ytimg.com/vi/xXmXM0qRMbo/maxresdefault.jpg",
    bio: "I am a Mathematics and Computer Science student at the University of Calgary. I love to travel, draw, workout and learn new things in general. Check out my LinkedIn profile and let's connect!",
    github: "https://github.com/thestarcar",
    linkedIn: "https://www.linkedin.com/in/kiaan-braganza-145b31214/",
  },
];
